import { reportError } from "./reportError";

const KEY = "evi_pending_order";
export const savePendingOrder = (orderId, packageId) => {
  try { sessionStorage.setItem(KEY, JSON.stringify({ orderId, package: packageId })); }
  catch (error) { reportError("Order retry preference could not be saved", error); }
};
export const clearPendingOrder = () => {
  try { sessionStorage.removeItem(KEY); }
  catch (error) { reportError("Order retry preference could not be cleared", error); }
};
export const readPendingOrder = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (typeof value?.orderId !== "string" || !/^[a-f0-9]{12}$/.test(value.orderId)) return null;
    return value;
  } catch (error) {
    reportError("Order retry preference could not be read", error);
    return null;
  }
};